import Sweep from './index';

export default { path: '/home/sweep', component: Sweep };
